module.exports = __webpack_public_path__ + "img/icon2.ab1f113c.png";